export const BOOK_ORIENTATION = {
    LANDSCAPE: 'LANDSCAPE',
    PORTRAIT: 'PORTRAIT',
};
